const REST_API_KEY = "6b97898043e2b728b95d9f34477686d0";
// 운영
// const REDIRECT_URI =  "https://m.floway.co.kr/users/login";
// 개발
const REDIRECT_URI = "https://dev.dnlt1sjfp3swg.amplifyapp.com/users/login";
// 로컬
// const REDIRECT_URI = "http://localhost:3000/users/login";

export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code`;
export const restAPI = REST_API_KEY;
export const redirectUri = REDIRECT_URI;
